// extracted by css-extract-rspack-plugin
export default {"ColumnFrame":"BoardColumnFrame-module__ColumnFrame__oXF2u"};